import React, { lazy } from 'react'

const LicensorPage = lazy(() => import('./LicensorPage'))

export { LicensorPage }
